/**
 * Web addresses and in-page anchors, from words.
 *
 * The same rules as server/src/lib/slugs.ts, so the address the panel suggests
 * while somebody types is the address the server accepts: lowercase, accents
 * folded, an ampersand read as "and", everything else a single hyphen.
 */
export function slugify(value: string, max = 80): string {
  return value
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, max)
    .replace(/-+$/g, "");
}

/** An id for an element a link can jump to, such as /where-we-work#bethanchowk. */
export const anchorId = (value: string) => slugify(value, 60) || "section";
